import { Address } from 'viem';

export const NFT_BONDS: Address = '0x969C6eCF97c256846029cBCBB865824E505E006f';
export const NFT_REDEMPTION: Address =
  '0x9fB9356278d4291A676b5c83b6A8eE0A009c18C4';
export const REWARD_POOL: Address =
  '0x0251cbB9a752331D29031eEc88c5a8BCbcDafFfa';
